import { Component, Input, NgModule } from '@angular/core';
import { findAll } from 'highlight-words-core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxHighlightWordsComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const chunk_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", chunk_r1.highlight && ctx_r0.highlightClassName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.textToHighlight.substr(chunk_r1.start, chunk_r1.end - chunk_r1.start));
} }
class NgxHighlightWordsComponent {
    constructor() {
        this.searchWords = [];
        this.highlightClassName = 'highlight';
    }
    /**
     * @return {?}
     */
    get chunks() {
        return findAll({
            textToHighlight: this.textToHighlight,
            searchWords: this.searchWords,
            autoEscape: this.autoEscape,
            caseSensitive: this.caseSensitive,
            findChunks: this.findChunks,
            sanitize: this.sanitize
        });
    }
}
NgxHighlightWordsComponent.ɵfac = function NgxHighlightWordsComponent_Factory(t) { return new (t || NgxHighlightWordsComponent)(); };
NgxHighlightWordsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NgxHighlightWordsComponent, selectors: [["ngx-highlight-words"]], inputs: { searchWords: "searchWords", highlightClassName: "highlightClassName", textToHighlight: "textToHighlight", autoEscape: "autoEscape", caseSensitive: "caseSensitive", findChunks: "findChunks", sanitize: "sanitize" }, decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"]], template: function NgxHighlightWordsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxHighlightWordsComponent_span_0_Template, 2, 2, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.chunks);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: [".highlight[_ngcontent-%COMP%] { background-color: yellow }"] });
NgxHighlightWordsComponent.propDecorators = {
    textToHighlight: [{ type: Input }],
    searchWords: [{ type: Input }],
    highlightClassName: [{ type: Input }],
    autoEscape: [{ type: Input }],
    caseSensitive: [{ type: Input }],
    findChunks: [{ type: Input }],
    sanitize: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxHighlightWordsComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-highlight-words',
                template: "<span\n  [ngClass]=\"chunk.highlight && highlightClassName\"\n  *ngFor=\"let chunk of chunks\">{{ textToHighlight.substr(chunk.start, chunk.end - chunk.start) }}</span>\n",
                styles: ['.highlight { background-color: yellow }']
            }]
    }], function () { return []; }, { searchWords: [{
            type: Input
        }], highlightClassName: [{
            type: Input
        }], textToHighlight: [{
            type: Input
        }], autoEscape: [{
            type: Input
        }], caseSensitive: [{
            type: Input
        }], findChunks: [{
            type: Input
        }], sanitize: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxHighlightWordsModule {
}
NgxHighlightWordsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxHighlightWordsModule });
NgxHighlightWordsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxHighlightWordsModule_Factory(t) { return new (t || NgxHighlightWordsModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxHighlightWordsModule, { declarations: function () { return [NgxHighlightWordsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxHighlightWordsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxHighlightWordsModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxHighlightWordsComponent],
                imports: [
                    CommonModule
                ],
                exports: [NgxHighlightWordsComponent]
            }]
    }], null, null); })();

export { NgxHighlightWordsComponent, NgxHighlightWordsModule };

//# sourceMappingURL=ngx-highlight-words.js.map